(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["karvaharja-product"] && !Shopify.designMode) return;
  try {
    
  const initKarvaharja = (root) => {
    if (root.dataset.khReady === 'true') return;
    root.dataset.khReady = 'true';

    const mainImage = root.querySelector('.kh-main-image');
    const thumbnails = root.querySelectorAll('[data-kh-thumb]');
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (mainImage) {
          mainImage.src = thumbnail.dataset.src;
          mainImage.alt = thumbnail.dataset.alt || '';
          mainImage.removeAttribute('srcset');
        }
        thumbnails.forEach((item) => item.classList.remove('is-active'));
        thumbnail.classList.add('is-active');
      });
    });

    const price = root.querySelector('[data-kh-price]');
    const stickyPrice = root.querySelector('[data-kh-sticky-price]');
    const stickyAddButton = root.querySelector('[data-kh-sticky-add]');
    const singlePrice = root.querySelector('[data-kh-single-price]');
    const addButton = root.querySelector('[data-kh-add]');
    const quantityInputs = root.querySelectorAll('.kh-deal-input');
    const variantInputs = root.querySelectorAll('.kh-variant-input');

    const updatePurchase = () => {
      const selectedQuantity = root.querySelector('.kh-deal-input:checked');
      const selectedVariant = root.querySelector('.kh-variant-input:checked');
      const selectedQuantityValue = selectedQuantity ? selectedQuantity.value : '1';
      const singleValue = selectedVariant ? selectedVariant.dataset.price : '';
      let displayedValue = singleValue;
      let buttonText = root.dataset.khSingleCta;

      if (selectedQuantityValue === '2') {
        displayedValue = root.dataset.khBundlePrice;
        buttonText = root.dataset.khBundleCta;
      } else if (selectedQuantityValue === '3') {
        displayedValue = root.dataset.khTriplePrice;
        buttonText = root.dataset.khTripleCta;
      }

      if (price && displayedValue) price.textContent = displayedValue;
      if (stickyPrice && displayedValue) stickyPrice.textContent = displayedValue;
      if (singlePrice && singleValue) singlePrice.textContent = singleValue;
      if (addButton && !addButton.disabled) {
        addButton.textContent = buttonText;
      }
    };

    if (stickyAddButton && addButton) {
      stickyAddButton.disabled = addButton.disabled;
      stickyAddButton.addEventListener('click', () => {
        if (!addButton.disabled) addButton.click();
      });
    }

    variantInputs.forEach((input) => input.addEventListener('change', updatePurchase));
    quantityInputs.forEach((input) => input.addEventListener('change', updatePurchase));
    updatePurchase();
  };

  document.querySelectorAll('[data-kh-section]').forEach(initKarvaharja);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-kh-section]');
    if (root) initKarvaharja(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
